// extracted by mini-css-extract-plugin
export var tabs = "_4OMj08HD";
export var active = "YbD6jibr";
export var hidden = "ZsuHVpG+";